{
  "schemaVersion": 1,
  "entries": [
    {
      "type": "google_compute_network",
      "provider": "gcp",
      "category": "network",
      "displayName": "VPC Network",
      "icon": "gcp/vpc-network",
      "isContainer": true,
      "documentationUrl": "https://registry.terraform.io/providers/hashicorp/google/latest/docs/resources/compute_network"
    },
    {
      "type": "google_compute_subnetwork",
      "provider": "gcp",
      "category": "network",
      "displayName": "Subnetwork",
      "icon": "gcp/subnetwork",
      "isContainer": true,
      "parentRules": [{ "attribute": "network", "priority": 1 }],
      "documentationUrl": "https://registry.terraform.io/providers/hashicorp/google/latest/docs/resources/compute_subnetwork"
    },
    {
      "type": "google_compute_instance",
      "provider": "gcp",
      "category": "compute",
      "displayName": "Compute Instance",
      "icon": "gcp/compute-instance",
      "parentRules": [
        { "attribute": "network_interface.subnetwork", "priority": 1 },
        { "attribute": "network_interface.network", "priority": 2 }
      ],
      "edgeRules": [{ "attribute": "service_account.email", "kind": "control", "show": false }],
      "documentationUrl": "https://registry.terraform.io/providers/hashicorp/google/latest/docs/resources/compute_instance"
    },
    {
      "type": "google_compute_firewall",
      "provider": "gcp",
      "category": "security",
      "displayName": "Firewall Rule",
      "icon": "gcp/firewall",
      "parentRules": [{ "attribute": "network", "priority": 1 }],
      "documentationUrl": "https://registry.terraform.io/providers/hashicorp/google/latest/docs/resources/compute_firewall"
    },
    {
      "type": "google_compute_router",
      "provider": "gcp",
      "category": "network",
      "displayName": "Cloud Router",
      "icon": "gcp/cloud-router",
      "parentRules": [{ "attribute": "network", "priority": 1 }],
      "documentationUrl": "https://registry.terraform.io/providers/hashicorp/google/latest/docs/resources/compute_router"
    },
    {
      "type": "google_compute_address",
      "provider": "gcp",
      "category": "network",
      "displayName": "IP Address",
      "icon": "gcp/ip-address",
      "parentRules": [{ "attribute": "subnetwork", "priority": 1 }],
      "documentationUrl": "https://registry.terraform.io/providers/hashicorp/google/latest/docs/resources/compute_address"
    },
    {
      "type": "google_compute_forwarding_rule",
      "provider": "gcp",
      "category": "loadbalancer",
      "displayName": "Forwarding Rule",
      "icon": "gcp/forwarding-rule",
      "parentRules": [
        { "attribute": "subnetwork", "priority": 1 },
        { "attribute": "network", "priority": 2 }
      ],
      "edgeRules": [{ "attribute": "backend_service", "kind": "traffic" }],
      "documentationUrl": "https://registry.terraform.io/providers/hashicorp/google/latest/docs/resources/compute_forwarding_rule"
    },
    {
      "type": "google_compute_disk",
      "provider": "gcp",
      "category": "storage",
      "displayName": "Persistent Disk",
      "icon": "gcp/persistent-disk",
      "documentationUrl": "https://registry.terraform.io/providers/hashicorp/google/latest/docs/resources/compute_disk"
    },
    {
      "type": "google_storage_bucket",
      "provider": "gcp",
      "category": "storage",
      "displayName": "Cloud Storage Bucket",
      "icon": "gcp/cloud-storage",
      "documentationUrl": "https://registry.terraform.io/providers/hashicorp/google/latest/docs/resources/storage_bucket"
    },
    {
      "type": "google_sql_database_instance",
      "provider": "gcp",
      "category": "database",
      "displayName": "Cloud SQL Instance",
      "icon": "gcp/cloud-sql",
      "parentRules": [{ "attribute": "settings.ip_configuration.private_network", "priority": 1 }],
      "documentationUrl": "https://registry.terraform.io/providers/hashicorp/google/latest/docs/resources/sql_database_instance"
    },
    {
      "type": "google_cloudfunctions2_function",
      "provider": "gcp",
      "category": "serverless",
      "displayName": "Cloud Function",
      "icon": "gcp/cloud-function",
      "edgeRules": [
        { "attribute": "service_config.service_account_email", "kind": "control", "show": false }
      ],
      "documentationUrl": "https://registry.terraform.io/providers/hashicorp/google/latest/docs/resources/cloudfunctions2_function"
    },
    {
      "type": "google_container_cluster",
      "provider": "gcp",
      "category": "container",
      "displayName": "GKE Cluster",
      "icon": "gcp/gke-cluster",
      "isContainer": true,
      "parentRules": [
        { "attribute": "subnetwork", "priority": 1 },
        { "attribute": "network", "priority": 2 }
      ],
      "documentationUrl": "https://registry.terraform.io/providers/hashicorp/google/latest/docs/resources/container_cluster"
    },
    {
      "type": "google_container_node_pool",
      "provider": "gcp",
      "category": "container",
      "displayName": "Node Pool",
      "icon": "gcp/node-pool",
      "parentRules": [{ "attribute": "cluster", "priority": 1 }],
      "documentationUrl": "https://registry.terraform.io/providers/hashicorp/google/latest/docs/resources/container_node_pool"
    },
    {
      "type": "google_service_account",
      "provider": "gcp",
      "category": "identity",
      "displayName": "Service Account",
      "icon": "gcp/service-account",
      "documentationUrl": "https://registry.terraform.io/providers/hashicorp/google/latest/docs/resources/service_account"
    },
    {
      "type": "google_logging_project_sink",
      "provider": "gcp",
      "category": "observability",
      "displayName": "Log Sink",
      "icon": "gcp/log-sink",
      "edgeRules": [{ "attribute": "destination", "kind": "data" }],
      "documentationUrl": "https://registry.terraform.io/providers/hashicorp/google/latest/docs/resources/logging_project_sink"
    }
  ]
}
